import { categories } from '@root/modules/customer/config/customer.config';

export const headlineSettings = {
  channel: true,
  lead: true,
  publishDate: true,
  author: false,
  titleComment: true,
  views: false,
  adsInject: {
    4: { type: 'mobile', mid: '457213', mark: true },
    9: { type: 'mobile', mid: '457214', mark: true },
    14: { type: 'mobile', mid: '457215', mark: true },
    19: { type: 'mobile', mid: '457216', mark: true },
    24: { type: 'mobile', mid: '457217', mark: true },
    29: { type: 'mobile', mid: '457213', mark: true },
    34: { type: 'mobile', mid: '457214', mark: true },
  },
};

export const searchCategories = categories.map((category) => {
  return {
    name: category.name,
    value: category.key,
    categories: category.categories,
  };
});
